<div
  *transloco="let t; read: 'calculator_result.result.values.annotations'"
  class="flex flex-col gap-2 font-bold">
  <psc-section-title
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>


  <!--  t(effectiveness, accuracy)-->
  <div *ngFor="let annotation of annotationList">
    *{{t(annotation)}}
  </div>
  <div>
    <ng-container *ngIf="taxIncluded">
      *{{t('tax')}}
    </ng-container>
    <ng-container *ngIf="!taxIncluded">
      *{{t('tax_not_included')}}
    </ng-container>
  </div>
</div>
